<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="show"
      class="gsl-hrm-confirmation-dialog gsl-hrm-dialog-popup"
      @update:show="onCancel"
    >
      <div class="gsl-hrm-modal-header">
        <oxd-text type="card-title">{{ title }}</oxd-text>
      </div>
      <div class="gsl-hrm-text-left-align">
        <oxd-text type="card-body">
          {{ subtitle }}
        </oxd-text>
      </div>
      <br />
      <div class="gsl-hrm-text-left-align">
        <oxd-text
          v-for="(name, index) in content"
          :key="index"
          type="card-body"
        >
          {{ name }}
        </oxd-text>
        <!-- <oxd-text type="card-body" v-html="subordinates"></oxd-text> -->
      </div>
      <div class="gsl-hrm-modal-footer">
        <oxd-button
          :label="cancelLabel"
          :display-type="cancelButtonType"
          class="gsl-hrm-button-margin"
          @click="onCancel"
        />
        <oxd-button
          :icon-name="icon"
          :label="confirmLabel"
          :display-type="confirmButtonType"
          class="gsl-hrm-button-margin"
          @click="onConfirm"
        />
      </div>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';

export default {
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    cancelLabel: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    confirmButtonType: {
      type: String,
      required: false,
      default: 'label-success',
    },
    cancelButtonType: {
      type: String,
      required: false,
      default: 'text',
    },
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
    };
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
      });
    },
    onConfirm() {
      this.show = false;
      this.resolve && this.resolve('ok');
    },
    onCancel() {
      this.show = false;
      this.resolve && this.resolve('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-modal-header {
  margin-bottom: 1.2rem;
  display: flex;
  justify-content: center;
}

.gsl-hrm-modal-footer {
  margin-top: 1.2rem;
  display: flex;
  justify-content: center;
}

.gsl-hrm-button-margin {
  margin: 0.25rem;
}

.gsl-hrm-text-center-align {
  text-align: center;
}
.gsl-hrm-text-left-align {
  text-align: left;
}
</style>
